/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { categoryDetailSubCategoriesStyles } from "@insite/content-library/Widgets/Category/CategoryDetailSubCategories";
import { css } from "styled-components";

categoryDetailSubCategoriesStyles.container = {
    gap: 15,
};

categoryDetailSubCategoriesStyles.subCategoryItem = {
    width: [12, 6, 4, 3, 2],
    css: css`
        margin-top: 15px !important;

        &:nth-child(1),
        &:nth-child(2),
        &:nth-child(3),
        &:nth-child(4),
        &:nth-child(5),
        &:nth-child(6) {
            margin-top: 0 !important;
        }
    `,
};
